import React, {useEffect} from 'react';
import {Button, Col, Container, Nav, Row, Tab} from "react-bootstrap";

const OrderInfo = ({basket,mart,address,setOrderStatus}) => {
    const [totalPrice, setTotalPrice] = React.useState(0);
    const [distance, setDistance] = React.useState(0);

    let rad = function(x) {
        return x * Math.PI / 180;
    };

    let getDistance = function(mart, address) {
        let R = 6378137; // Earth’s mean radius in meter
        let dLat = rad(address.geoLat - mart.geoLat);
        let dLong = rad(address.geoLon - mart.geoLon);
        let a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(rad(mart.geoLat)) * Math.cos(rad(address.geoLat)) *
            Math.sin(dLong / 2) * Math.sin(dLong / 2);
        let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        let d = R * c;
        setDistance(d)
    };

    useEffect(() => {
        getDistance(mart, address)

        let sum = 0
        basket.filter(basketItem => basketItem.product.martId === mart.id && basketItem.quantity > 0 && (sum = sum + basketItem.product.price * basketItem.quantity));
        setTotalPrice(sum)
    }, []);

    return (
        <Container>
            <p>Подтверждение заказа</p>
            <p>Адрес доствки</p>
            <p>ул. {address.street}, д. {address.apartment}, кв. {address.number}, подъезд {address.entrance}</p>
            <hr/>
            <p>Способ оплаты</p>

            <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                <Nav className="flex-column">
                    <Row>
                        <Col>
                            <Nav.Item>
                                <Nav.Link eventKey="first"><p className={'btn-success'}>Наличными</p></Nav.Link>
                            </Nav.Item>
                        </Col>
                        <Col> <Nav.Item>
                            <Nav.Link eventKey="second">СПБ</Nav.Link>
                        </Nav.Item></Col>
                    </Row>
                </Nav>
                <Tab.Content>
                    <Tab.Pane eventKey="first">При оплате наличными, просим подготовить оплату курьеру без
                        сдачи</Tab.Pane>
                    <Tab.Pane eventKey="second">Оплата по QR коду курьеру</Tab.Pane>
                </Tab.Content>
            </Tab.Container>

            <p>Доставка: {distance > 500 ?
                <> 120 Р</>
                :
                <>Бесплатная доставка</>
            }
            </p>
            <p>Итоговая сумма {totalPrice} Р</p>
            <p>Итог к оплате {distance > 500 ?
                <> {totalPrice + 120}</>
                :
                <>{totalPrice}</>
            } Р</p>

            <Button onClick={() => setOrderStatus(true)}>Подтвердить</Button>
        </Container>
    );
};

export default OrderInfo;